export default __webpack_public_path__ + "static/media/1369.24bec9cf.png";